import React from 'react';
import { Mail, Phone, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const whatsappNumber = "5535988192707";
  const whatsappUrl = `https://wa.me/${whatsappNumber}`;

  return (
    <footer className="bg-[#033530] text-[#e8d6b2] pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center">
                <img
                  src="/assets/logo-new.png"
                  alt="Amanda Sales Logo"
                  className="w-full h-full object-contain" />

              </div>
              <h3 className="text-2xl font-bold text-[#ddc183]" style={{ fontFamily: "'Cinzel Decorative', serif" }}>Amanda Sales</h3>
            </div>
            <p className="text-[#e8d6b2]/80 mb-6 leading-relaxed">
              Especialistas em projetos de engenharia e perícia técnica com excelência e precisão.
            </p>
            <div className="flex gap-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-[#ddc183] rounded-full flex items-center justify-center hover:bg-[#c9af71] transition-colors duration-200"
                aria-label="Facebook">

                <Facebook size={20} className="text-[#033530]" />
              </a>
              <a
                href="https://www.instagram.com/amandasales_eng?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-[#ddc183] rounded-full flex items-center justify-center hover:bg-[#c9af71] transition-colors duration-200"
                aria-label="Instagram">

                <Instagram size={20} className="text-[#033530]" />
              </a>
              <a
                href="https://www.linkedin.com/in/amandasalesassiscruz"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-[#ddc183] rounded-full flex items-center justify-center hover:bg-[#c9af71] transition-colors duration-200"
                aria-label="LinkedIn">

                <Linkedin size={20} className="text-[#033530]" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold text-[#ddc183] mb-4">Links Rápidos</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('home')}
                  className="text-[#e8d6b2]/80 hover:text-[#ddc183] transition-colors duration-200">

                  Início
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('servicos')}
                  className="text-[#e8d6b2]/80 hover:text-[#ddc183] transition-colors duration-200">

                  Serviços
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('portfolio')}
                  className="text-[#e8d6b2]/80 hover:text-[#ddc183] transition-colors duration-200">

                  Portfólio
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('diferenciais')}
                  className="text-[#e8d6b2]/80 hover:text-[#ddc183] transition-colors duration-200">

                  Diferenciais
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contato')}
                  className="text-[#e8d6b2]/80 hover:text-[#ddc183] transition-colors duration-200">

                  Contato
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold text-[#ddc183] mb-4">Nossos Serviços</h4>
            <ul className="space-y-3 text-[#e8d6b2]/80">
              <li>Regularização e legalização de imóveis</li>
              <li> Pericias Judiciais</li>
              <li>Inspeção Predial</li>
              <li>Diagnostico de patologias</li>
              <li>Avaliação de imóveis</li>
              <li>Projetos diversos de Engenharia e arquitetura</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold text-[#ddc183] mb-4">Contato</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone size={20} className="text-[#ddc183] mt-1 flex-shrink-0" />
                <div>
                  <a
                    href={whatsappUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#e8d6b2]/80 hover:text-[#ddc183] transition-colors duration-200">

                    +55 35 98819-2707
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={20} className="text-[#ddc183] mt-1 flex-shrink-0" />
                <a
                  href="mailto:contato@amandasales.eng.br"
                  className="text-[#e8d6b2]/80 hover:text-[#ddc183] transition-colors duration-200">amandaassis.sales@gmail.com


                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={20} className="text-[#ddc183] mt-1 flex-shrink-0" />
                <span className="text-[#e8d6b2]/80">
                  Minas Gerais, Brasil
                </span>
              </li>
            </ul>
            <div className="mt-6">
              <span className="text-[#ddc183] font-medium">CREA-MG</span>
              <p className="text-[#e8d6b2]/80 text-sm mt-1">CREA/MG 240.255/D</p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#ddc183]/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-[#e8d6b2]/60 text-sm">
              © {currentYear} Amanda Sales Engenharia. Todos os direitos reservados.
            </p>
            <div className="flex gap-6 text-sm">
              <a href="#" className="text-[#e8d6b2]/60 hover:text-[#ddc183] transition-colors duration-200">
                Política de Privacidade
              </a>
              <a href="#" className="text-[#e8d6b2]/60 hover:text-[#ddc183] transition-colors duration-200">
                Termos de Uso
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>);

};

export default Footer;